import { action, computed, makeObservable, observable } from 'mobx'

interface IReleaseControlViewStore<T> {
  id?: number
  isDeleteDialogOpen: boolean
  isLoading: boolean
  isEditMode: boolean

  setId: (id: number) => void
  toggleDeleteDialog: (shouldOpen: boolean) => void
  setIsLoading: (isLoading: boolean) => void

  onSubmit?: (data: T) => Promise<void>
}

export abstract class ReleaseControlViewStore<T> implements IReleaseControlViewStore<T> {
  id?: number

  isDeleteDialogOpen = false
  isLoading = false

  constructor() {
    makeObservable(this, {
      id: observable,
      isLoading: observable,

      isEditMode: computed,

      setId: action,
      toggleDeleteDialog: action,
      setIsLoading: action,
    })
  }

  setId = (id: number) => (this.id = id)

  setIsLoading = (isLoading: boolean) => (this.isLoading = isLoading)

  toggleDeleteDialog = (shouldOpen: boolean) => (this.isDeleteDialogOpen = shouldOpen)

  get isEditMode() {
    return !!this.id
  }
}
